import { createContext, type ReactNode, useReducer, Dispatch } from 'react'
import {
  DevelopusSnackbarState,
  developusInitialSnackbarState,
} from './DevelopusSnackbarState'
import {
  DevelopusSnackbarReducerAction,
  developusSnackbarReducer,
} from './developusSnackbar-reducer'

interface Props {
  children: ReactNode
}

export interface DevelopusSnackbarContextType {
  state: DevelopusSnackbarState
  dispatch: Dispatch<DevelopusSnackbarReducerAction>
}

const DevelopusSnackbarContext = createContext<DevelopusSnackbarContextType>({
  state: developusInitialSnackbarState,
  dispatch: () => {},
})

export const DevelopusSnackbarContextProvider: any = ({ children }: Props) => {
  const [state, dispatch] = useReducer(
    developusSnackbarReducer,
    developusInitialSnackbarState,
  )

  return (
    <DevelopusSnackbarContext.Provider value={{ state, dispatch }}>
      {children}
    </DevelopusSnackbarContext.Provider>
  )
}

export default DevelopusSnackbarContext
